import React from "react"

import CirclesBurst from "./CirclesBurst"

const CirclesBurstSet = ({ ready, color, className }) => {
  return (
    <div className={className && className}>
      <CirclesBurst color={color} ready={ready} size="huge" />
      <CirclesBurst color={color} ready={ready} size="large" />
      <CirclesBurst color={color} ready={ready} size="medium" />
      <CirclesBurst color={color} ready={ready} size="small" />
    </div>
  )
}

export default CirclesBurstSet
